import * as Popover from '@radix-ui/react-popover';
import { Keyboard } from 'lucide-react';
import { Button } from '../../components/ui';
import { LIST_SHORTCUTS } from './ticket-table';

/**
 * What the list's keys do, on screen.
 *
 * Shortcuts nobody can discover are shortcuts nobody uses. This lists exactly
 * the ones the table answers to — the same list the handler is kept in step
 * with — so learning them is one click away rather than a matter of luck.
 */
export function ListShortcuts() {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <Button size="icon" variant="secondary" aria-label="Keyboard shortcuts" title="Keyboard shortcuts">
          <Keyboard aria-hidden className="size-3.5" />
        </Button>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content
          align="end"
          sideOffset={6}
          aria-label="Keyboard shortcuts"
          className="animate-pop z-50 w-80 rounded-card border border-line bg-raised p-3 shadow-float"
        >
          <p className="pb-2 text-body font-medium text-ink">Keyboard shortcuts</p>
          <dl className="space-y-1.5">
            {LIST_SHORTCUTS.map((shortcut) => (
              <div key={shortcut.does} className="flex items-start gap-3">
                <dt className="flex w-24 shrink-0 flex-wrap gap-1">
                  {shortcut.keys.map((key) => (
                    <kbd
                      key={key}
                      className="rounded border border-line-strong bg-sunken px-1.5 font-sans text-mini text-ink"
                    >
                      {key}
                    </kbd>
                  ))}
                </dt>
                <dd className="text-mini text-ink-muted">{shortcut.does}</dd>
              </div>
            ))}
          </dl>
          <p className="mt-2 text-mini text-ink-subtle">Row shortcuts act on the row that has focus.</p>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
